namespace GeniuzPOS.Common.Helpers {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class WmsFlagFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];
            // console.log('Charnel : ' + chanel);
            if (chanel == 0) {
                return "<i class='fa fa-file text-yellow' style='font-size: 13px;'" +
                    "'> " + "ร่าง" + '</i>';
            } else if (chanel == 1) {
                return "<i class='fa fa-check-square text-green' style='font-size: 13px;'" +
                    "'> " + "อนุมัติแล้ว" + '</i>';
            } else if (chanel == 2) {
                return "<i class='fa fa-window-close text-red' style='font-size: 13px;'" +
                    "'> " + "ยกเลิก" + '</i>';
            } else if (chanel == 3) {
                return "<i class='fa fa-file text-yellow' style='font-size: 13px;'" +
                    "'> " + "ส่งกลับแก้ไข" + '</i>';
            } else {
                return chanel
            }


        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }
}